<template>
    <div>
        
        <h4 class="mb-2 border-bottom pb-2 mt-5">{{pagetitle}}</h4>
        <div class="card border-0 mt-0 bg-wash no-shadow">
            
            <b-overlay :show="showoverlay" rounded="sm">
                <div class="container-fluid px-0">
                    <div class="row no-gutters py-2 mb-3 border-bottom">
                        <div class="col-sm-6 pl-0">
                            <div class="company-form-box-title custom-search">
                                <b-input-group class="mb-2">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="search"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input type="search" placeholder="Search.." v-model="search" @input="resetPagination()"></b-form-input>
                                </b-input-group>
                            </div>
                        </div>
                        <div class="col-sm-6 cursor-pointer text-right company-form-box-title pr-0">
                            <b-form-select v-model="month" :options="months" class="w-25" @change="getLogData"></b-form-select>
                            <b-form-select v-model="year" :options="years" class="w-25" @change="getLogData"></b-form-select>
                        </div>
                    </div>
                    
                    <table class="table dataTable"> 
                        <thead>
                            <tr class="table-head">
                                <th v-for="column in columns" :key="column.name" @click="sortBy(column.name)":class="sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"style="cursor:pointer;"><span>{{column.label}}</span></th>
                                <th>Details</th>
                            </tr>
                        </thead>            
                        <tbody>
                            <tr class="hover-bg table-row mx-2" v-for="log in paginatedData" :key="log.id">
                                <td>{{  formatMe( log.created_at )   }}</td>
                                <td>{{log.name}}</td> 
                                <td>{{log.email}}</td>                                
                                <td>{{ modules[log.module].text }}</td>
                                <td>{{log.details}}</td>
                                
                            </tr>
                            <tr v-if="paginatedData.length > 0"><td :colspan="6">
                            <div class="row p-2 float-right" >
                                <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav>
                            </div></td></tr>
                            <tr v-if="paginatedData.length == 0"><td :colspan="6">{{blankmsg}}</td></tr>
                        </tbody>
                    </table>
                </div>
            </b-overlay>    
        </div>
        
    </div>
</template>


<script>
    import moment from 'moment';
    export default{
        
        mounted() {
            //console.log('Bank info started..');   
            //console.log(this.employee_id);  
            
        },
        data(){   
            
            let sortOrders = {};
            let columns = [
                            {label: 'Sent at', name: 'created_at' },
                            {label: 'Name', name: 'name'},
                            {label: 'Email', name: 'email'},
                            {label: 'Module', name: 'module'},                            
                        ];
            columns.forEach((column) => {sortOrders[column.name] = -1;});

            const d = new Date();
            
            return {
                
                ce : true, 
                logs : [],
                showoverlay : false,

                pagetitle: 'eMail Log',
                blankmsg : 'Fetching data..',

                search : '',
                
                modules: [                    
                    { value: "0", text: "Default" },
                    { value: "1", text: "Core HR" },
                    { value: "2", text: "blaa.." },
                ],

                months: [                                        
                    { value: "1", text: "January" },
                    { value: "2", text: "February" },
                    { value: "3", text: "March" },
                    { value: "4", text: "April" },
                    { value: "5", text: "May" },
                    { value: "6", text: "June" },
                    { value: "7", text: "July" },
                    { value: "8", text: "August" },
                    { value: "9", text: "September" },
                    { value: "10", text: "October" },
                    { value: "11", text: "November" },
                    { value: "12", text: "December" },
                ],

                years : ['2020' , '2021' , '2022'],

                month : d.getMonth()+1,
                year : d.getFullYear(),

                columns: columns,
                sortKey: 'created_at',
                sortOrders: sortOrders,
                length : 20,
                pagination : {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},

            }
        },
        methods:{
            formatMe(d)
            {
                return moment(d).format('YYYY-MM-DD hh:mm:ss A');
            },
            getLogData: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/email-log/data?year='+this.year+'&month='+this.month , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    //console.log(response.data);
                    this.logs = response.data;
                    if(this.logs.length == 0)
                        this.blankmsg = "Nothing found.";
                    else
                        this.sortBy('created_at');
                        
                }.bind(this)).catch(function (error){currentObj.serverError(error);});



            }, 

        },
        created: function(){            
            this.getLogData();
            Fire.$on('reloadLogs', () => {this.getLogData()})
        },
        computed: 
        {
            filteredData() 
            {
                let filtered_list = this.logs;
                if (this.search) 
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                
                    if(filtered_list.length == 0)
                        this.blankmsg = "Nothing found.";                
                }

                let sortKey = this.sortKey;
                let order = this.sortOrders[sortKey] || 1;
                if (sortKey) 
                {
                    filtered_list = filtered_list.slice().sort((a, b) => {let index = this.getIndex(this.columns, 'name', sortKey);
                            a = String(a[sortKey]).toLowerCase();
                            b = String(b[sortKey]).toLowerCase();
                            if (this.columns[index].type && this.columns[index].type === 'date') 
                            {
                                return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                            } 
                            else if (this.columns[index].type && this.columns[index].type === 'number') 
                            {
                                return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                            } 
                            else 
                            {
                                return (a === b ? 0 : a > b ? 1 : -1) * order;
                            }
                        }
                    );
                }
                
                return filtered_list;
            },
            paginatedData() 
            {     
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            }
        }
    }
</script>
